export default "__VITE_ASSET__DATr45p___"